module.exports = __webpack_public_path__ + "static/shootingstar-441f46f7a10f849be8512d89b0839977.webp";